import { useRecoilState } from 'recoil';
import { useCallback, useEffect } from 'react';
import { selfAffiliateCodeAtom } from '../atoms/Affiliate';
import { isTokenValid } from '../utils/Auth';
import { getSelfAffiliateCode } from '../api/Affiliate';

export const useSelfAffiliateCode = () => {
  const [selfAffiliateCode, setSelfAffiliateCode] = useRecoilState(
    selfAffiliateCodeAtom,
  );

  const refresh = useCallback(() => {
    if (isTokenValid()) {
      getSelfAffiliateCode()
        .then(setSelfAffiliateCode)
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err));
    } else {
      setSelfAffiliateCode(null);
    }
  }, []);

  useEffect(() => {
    if (selfAffiliateCode === undefined) refresh();
  }, [selfAffiliateCode]);

  return {
    selfAffiliateCode,
    refresh,
  };
};
